import React from 'react';
import { useCollections } from '@tribeplatform/react-sdk/hooks';
import { GridList } from '@tribeplatform/react-ui-kit/Layout';
import { CollectionCard } from './CollectionCard.js';
import { CollectionListLoading } from './CollectionListLoading.js';
export const CollectionListBlock = () => {
    const { data: collections, isFetching } = useCollections({
        fields: 'basic',
    });
    return (React.createElement(GridList, { columns: 4 }, collections === null || collections === void 0 ? void 0 :
        collections.map(collection => (React.createElement(GridList.Item, { key: collection.id },
            React.createElement(CollectionCard, { collection: collection })))),
        isFetching ? React.createElement(CollectionListLoading, null) : null));
};
//# sourceMappingURL=Block.js.map